<template>
    <div class="zoom-panel">
        <Button
            @click="zoomIn"
            v-tippy="{ placement: 'left' }"
            content="Zoom in"
            aria-label="Zoom in"
            class="zoom-in-button"
        >
            <svg
                width="10px"
                height="10px"
                viewBox="0 0 10 10"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon
                        id="Path"
                        fill="#000000"
                        points="4 10 6 10 6 6 10 6 10 4 6 4 6 0 4 0 4 4 0 4 0 6 4 6"
                    ></polygon>
                </g>
            </svg>
        </Button>
        <Button
            @click="zoomOut"
            v-tippy="{ placement: 'left' }"
            content="Zoom uit"
            aria-label="Zoom uit"
        >
            <svg
                width="10px"
                height="2px"
                viewBox="0 0 10 2"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Path" fill="#000000" points="10 2 10 0 0 0 0 2"></polygon>
                </g>
            </svg>
        </Button>
    </div>
</template>

<script>
import Button from '../Button.vue'

export default {
    name: 'ZoomPanel',
    components: {
        Button,
    },
    methods: {
        zoomIn() {
            this.$emit('adjust-zoom', 1)
        },
        zoomOut() {
            this.$emit('adjust-zoom', -1)
        },
    },
    props: {
        position: Object,
    },
}
</script>

<style scoped>
.zoom-panel {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: var(--radius-normal);
    overflow: hidden;
    box-shadow: var(--shadow-normal);
}

.zoom-panel .button {
    border-radius: 0;
    border: none;
}

.button.zoom-in-button {
    border-bottom: 1px solid var(--color-grey-30);
}
</style>
